import { useMemo } from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { useSelector } from "react-redux";
import {
    selectAuthUserDetails,
    selectIsAuthUserDetailsLoading,
    selectIsAuthUserNotRegistered
} from "../../store/auth/login/selectors";
import { UserRole } from "../../constants/user-role";

const useAuthUser = () => {
    const isAuthenticated = useIsAuthenticated();
    const authUserDetails = useSelector(selectAuthUserDetails());
    const isAuthUserDetailsLoading = useSelector(selectIsAuthUserDetailsLoading());
    const isAuthUserNotRegistered = useSelector(selectIsAuthUserNotRegistered());
    const isAdmin = useMemo(() => !!authUserDetails?.appRoles.find(({ roleName })=> roleName === UserRole.ADMIN), [authUserDetails]);
    const isUser = useMemo(() => !!authUserDetails?.appRoles.find(({ roleName })=> roleName === UserRole.USER) || authUserDetails?.appRoles !== undefined, [authUserDetails]);
    const isDealer = useMemo(() => !!authUserDetails?.appRoles.find(({ roleName })=> roleName === UserRole.DEALER), [authUserDetails]);

    return {
        user: authUserDetails,
        isAdmin,
        isUser,
        isRegistered: isAuthenticated,
        isDataLoading: isAuthUserDetailsLoading,
        isAuthUserNotRegistered,
        isDealer,
    };
};

export default useAuthUser;
